<div class="card-header">
    <div style="margin: 1rem">
        <search-bar label="Search for a vehicle by VIN, stock ID, or vehicle year, make, model, trim or color" [isFiltered]="isFiltered" (outEvent)="eventHandler($event)"> </search-bar>
    </div>

    <ng-container *ngIf="vehicles.length <= 0 && !loading">
        <p class="vehicles">No vehicles match your search criteria</p>
    </ng-container>

    <ng-container *ngIf="loading">
        <!-- <p class="vehicles">Getting Vehicles...</p> -->
        <three-dot-loader></three-dot-loader>
    </ng-container>

    <ng-container *ngIf="!loading && vehicles && vehicles.length > 0">
        <h2 style="margin: 0 1rem">Vehicle{{ vehicles.length > 1 ? 's' : '' }} Found</h2>
        <ul>
            <li *ngFor="let v of vehicles">
                <app-vehicle [vehicle]="v" [condensed]="true" (selected$)="vehicleSelected($event)" [selected]="v.vin === vehicle?.vin"> </app-vehicle>
            </li>
        </ul>
    </ng-container>
</div>
